import { writable } from "svelte/store"

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    hash: (typeof window !== "undefined" && window.location?.hash) || "",
    push: false,
    pop: false,
    categoryPath: "",
}
export const location = writable(initLoc)
export const content = writable({})
export const openedElements = writable({
    mainPoint: null,
    subPoint: null,
})
export const language = writable("german")
export const navigation = writable<Navigation[]>([])
